export default __webpack_public_path__ + "static/media/casaduana_ApartaTuLugar.a20e55f8.svg";